/* OOKIES theme.js v2 */
(function () {
  'use strict';

  // Sticky header
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile drawer
  var toggle = document.querySelector('.mobile-toggle');
  var drawer = document.querySelector('.mobile-drawer');
  if (toggle && drawer) {
    toggle.addEventListener('click', function () { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
    var close = drawer.querySelector('.close');
    if (close) close.addEventListener('click', function () { drawer.classList.remove('is-open'); document.body.style.overflow = ''; });
  }

  // Variant swatches (generic group toggle)
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.variant-swatch, .diopter-pill, .filter-pill');
    if (!swatch) return;
    var group = swatch.parentElement;
    if (!group) return;
    group.querySelectorAll('.variant-swatch, .diopter-pill, .filter-pill').forEach(function (s) { s.classList.remove('is-selected', 'is-active'); });
    swatch.classList.add('is-selected');
    swatch.classList.add('is-active');
    var img = swatch.getAttribute('data-image');
    var gallery = document.querySelector('.product-gallery img');
    if (img && gallery) gallery.src = img;
  });

  // Tabs
  document.querySelectorAll('.tab-list').forEach(function (list) {
    list.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-tab]');
      if (!btn) return;
      var target = btn.getAttribute('data-tab');
      list.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var container = list.closest('.product-tabs');
      if (!container) return;
      container.querySelectorAll('.tab-panel').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-panel') === target);
      });
    });
    // init first tab
    var first = list.querySelector('button[data-tab]');
    if (first) first.click();
  });

  // Password input focus
  var pw = document.querySelector('.password-wrap input');
  if (pw) pw.focus();

  // Duplicate marquee content for seamless loop
  var marquee = document.querySelector('.announcement__track');
  if (marquee) {
    marquee.innerHTML = marquee.innerHTML + marquee.innerHTML;
  }
})();
